// @flow
export { ConfirmationDialog } from "./ConfirmationDialog";
export { withConfirmation } from "./withConfirmation";
export type { WithConfirmationProps } from "./withConfirmation";
